<script>
import ApiClient from '../utils/ApiClient'
export default {
  name: 'ContactService',
  /**
   * お問い合わせの送信
   * @param name01
   * @param name02
   * @param email
   * @param contents
   * @param tel
   * @param callback
   * @param errorHandler
   **/
  postContact: function (name01, name02, email, contents, tel = null, callback, errorHandler) {
    const targetPath = 'ajax/contact.php'
    let formData = new URLSearchParams()
    formData.append('name01', name01)
    formData.append('name02', name02)
    formData.append('email', email)
    formData.append('contents', contents)
    formData.append('tel', tel)
    ApiClient.create(targetPath, formData, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('postContact failed')
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/ContactService.vue